module.exports = __webpack_public_path__ + "static/media/1.715c757a.png";